import React, { useRef } from 'react';
import cx from 'classnames';
import _ from 'lodash';


import CheckInput from 'components/forms/CheckInput';
import ChannelCard from 'components/ChannelCard';
import Scrollbars from 'components/Scrollbars';



// ======================
// PARTIALS
// ====================== 
export const PickItem = ({ children, itemId, selected, selectMultiple = true, onSelectItem, onRemoveItem, ...props}) => {
  let checkRef = useRef();
  let onClick = () => selected 
    ? onRemoveItem?.(itemId)
    : onSelectItem?.(itemId);
  return (
    <div className={cx("g-pick-item", { selected })} onClick={onClick}>
      <div className="item-info">
        {children}
      </div>
      <div className="item-check">
        {selectMultiple && 
        <CheckInput ref={checkRef} name={itemId} value={selected} />}
        {!selectMultiple && 
        <input type="radio" name={'item-picker'} checked={selected} onChange={e => {
          if(e.target.value === "on")
            onSelectItem(itemId)
        }} />}
      </div>
    </div>);
}


export const ChannelItem = ({channel,...props}) => (
  <PickItem {...props}>
    <ChannelCard channel={channel} />
  </PickItem>
)


export const CampaignItem = ({campaign, brand,...props}) => (
  <PickItem {...props}>
    <div className="item-name">
      { `${brand.name}: ${campaign.name}`}
    </div>
  </PickItem>
)




// ======================
// COMPONENT>
// ====================== 
export class ItemPicker extends React.Component {
  render() {
    let { children, selectedItems, onSelectItem, onRemoveItem, selectMultiple = true, } = this.props;
    return (
      <div className="g-item-picker">
        <Scrollbars>
        {_.map(children, (item, idx) => {
          return React.cloneElement(item, {
          ...item.props,
          selected: _.includes(selectedItems, item.props.itemId),
          selectMultiple,
          onSelectItem,
          onRemoveItem: selectMultiple ? onRemoveItem : undefined
          })
        })} 
        </Scrollbars>
      </div>)
  }
}
export default ItemPicker;
